import {RouteConfig} from "vue-router";

const complaintCustomerRoutes: Array<RouteConfig> = [
    {
        path: "complaint",
        component: () => import("./List/index.vue"),
        name: "complaintCustomerList",
        meta: { title: "Khiếu nại" }
    }
]

export default complaintCustomerRoutes;